import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {Navigate} from 'react-router-dom';

import {ErrorMessageComponent} from 'features/error-messages/hoc/ErrorMessageComponent';

import {requestPasswordChange} from '../reducers/recordsSlice';

import {I18n} from '@aws-amplify/core';

import EmailForm from 'features/accounts/forms/EmailForm';

import {requestResultSelector} from '../selectors';

import {useErrorMessage} from 'hooks/useErrorMessage';

import {Box, SimpleGrid} from '@mantine/core';

import {useAccount} from 'hooks/useAccount';

export const RequestPage = () => {
    const account = useAccount();

    const dispatch = useDispatch();

    const errorMessage = useErrorMessage();

    const requestResult = useSelector((state) => requestResultSelector(state));

    const handleSubmit = (values, { setSubmitting }) => {
        dispatch(
            requestPasswordChange({
                account,
                emailAddress: values.email.toLowerCase(),
            })
        );

        // this allowes for the user to enter new value if the reset command fails
        setSubmitting(false);
        return false;
    };

    if (typeof account === 'undefined' || account === null) {
        return <Navigate to="/404" />;
    }

    if (requestResult === 'success') {
        return <Navigate to={`/reset-password/confirm/${account.id}`} />;
    }

    if (errorMessage) {
        return <ErrorMessageComponent error={errorMessage} />;
    }

    let initialValues = { email: '' };
    if (typeof account !== 'undefined') {
        if (account !== null) {
            initialValues.email = account['emailAddress'];
        }
    }

    return (
        <SimpleGrid>
            <Box variant="h2">{I18n.get('Reset Password')}</Box>
            <Box>
                {I18n.get('Enter your email address to get verification code')}
            </Box>
            <Box mt="xl">
                <EmailForm handleSubmit={handleSubmit} record={initialValues} />
            </Box>
        </SimpleGrid>
    );
};
